import React, { useEffect, useState } from "react";
import { useUnidades } from "../hooks/test/useUnidades";
import Select from "react-select";

export const Test = () => {
  const [respuesta, setRespuesta] = useState(null);
  const {
    // postTripulanteViaje,
    getTiendasNegocio,
    // getUnidadesFormatoSalida,
    // getUnidadesEnRuta,
    // getTiendasViaje,
    // getTripulacionViaje,
    // postViaje,
    // putViaje,
    // postCheckPrueba,
    // postTipulantes,
    // deleteTipulantes,
    // createRutas,
    // createRuta,
    // deleteRuta,
    // getUnidad,
    // getChoferesCedisId,
    // getBitacoraViaje,
    // postBitacora,
    // getListaCedis,
    // getTableroGerencial,
    // getListaEstatus,
    // getRoles,
    // getTiendasCedis,
    // getTienda,
  } = useUnidades();
  useEffect(() => {
    exec();
  }, []);
  const exec = async () => {
    /**Este hook es para traer todas las unidades de formato salida */
    // let resp = await getUnidadesFormatoSalida();
    /**Este hook es para traer las unidades en ruta */
    // let resp = await getUnidadesEnRuta();
    // Este hook es para traer las tiendas de un viaje
    // let resp = await getTiendasViaje(108);
    // Hook para traer la tripulación de un viaje
    // let resp = await getTripulacionViaje(110);
    // Hook para crear un viaje
    // let resp = await postViaje({
    //   unidad_id: 5,
    //   chofer_id: 1,
    //   cedis_id: 3,
    //   marchamo: "marchamo",
    //   cajas: 10,
    //   descripcion: "descripcion",
    //   fecha_hora_salida: "2022-01-01 00:00:00",
    //   fecha_hora_regreso: "2022-01-01 00:00:00",
    //   status: 6,
    // });
    // Hook para actualizar un viaje
    // let resp = await putViaje({
    //   unidad_id: 1,
    //   viaje_id: 115,
    //   chofer_id: 1,
    //   cedis_id: 1,
    //   marchamo: "ma",
    //   cajas: "15",
    //   descripcion: "asdasdasd",
    //   fecha_hora_salida: "2022-01-02 01:02:01",
    //   fecha_hora_regreso: "2022-01-02 01:02:01",
    //   status: "1",
    // });
    // let resp = await postCheckPrueba({
    //   viaje_id: 115,
    //   guardia_id: 7,
    //   monitorista_id: 1,
    //   paro_motor: false,
    //   boton_panico: true,
    //   conectividad: false,
    // });
    // let resp = await postTipulantes({
    //   id_viaje: 115,
    //   tripulantes: [
    //     {
    //       maniobrista_id: 1,
    //     },
    //     {
    //       maniobrista_id: 1,
    //     },
    //   ],
    // });
    // Eliminar tripulantes
    // let resp = await deleteTipulantes(125);
    // let resp = await createRutas({
    //   viaje_id: 115,
    //   tiendas: ["1280", "1496"],
    // });
    //
    // let resp = await createRuta({
    //   viaje_id: 115,
    //   tienda_id: 1,
    // });
    // let resp = await deleteRuta(1);
    // let resp = await getChoferesCedisId(1);
    // let resp = await getBitacoraViaje(1);
    // let resp = await postBitacora({
    //   id_viaje: 112,
    //   id_monitorista: 1,
    //   fecha: "2020-01-01 00:00:00",
    //   notas: "Prueba de bitacora",
    //   id_status: 1,
    // });
    // let resp = await getTienda(140);
    // setRespuesta(resp);
    let resp = await getTiendasNegocio(2);
    setRespuesta(resp);
  };
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const handleChange = (listValues) => {};

  return (
    <div>
      <code>{JSON.stringify(respuesta)}</code>
      <Select
        options={options}
        isMulti
        className="basic-multi-select"
        classNamePrefix={"select"}
        onChange={handleChange}
      />
    </div>
  );
};
